export default "__VITE_ASSET__15ed68c5__"